import * as Api from '../../../api/Api';
import { useEffect, useState, useContext } from 'react';
import { useGetToken } from '../../../Hooks/CustomHooks';
import { useQuery } from 'react-query';
import { Loading } from '../../../Components/Loading/Loading';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import { Modal } from 'react-bootstrap-v5';
import * as KeyNames from '../../../api/KeyNames';
import { useForm } from 'react-hook-form';

export default function GestionLocatario({ contrato, listaClasificacionComercial, listaClasificacionSubComercial, listaCategoria, setSmShow }) {
    const token = useGetToken();

    const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm();

    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);

    const [operadorCorreo, setOperadorCorreo] = useState((contrato.operador.email) ? contrato.operador.email : null);
    const [operadorNombre, setOperadorNombre] = useState((contrato.operador.name) ? contrato.operador.name : null);
    const [operadorClave, setOperadorClave] = useState((contrato.operador.password) ? contrato.operador.password : null);
    const [administradorCorreo, setAdministradorCorreo] = useState((contrato.administrador.email) ? contrato.administrador.email : null);
    const [administradorNombre, setAdministradorNombre] = useState((contrato.administrador.name) ? contrato.administrador.name : null);
    const [administradorClave, setAdministradorClave] = useState((contrato.administrador.password) ? contrato.administrador.password : null);
    const [financieroOneCorreo, setFinancieroOneCorreo] = useState((contrato.financiero1?.email) ? contrato.financiero1.email : "");
    const [financieroOneNombre, setFinancieroOneNombre] = useState((contrato.financiero1?.name) ? contrato.financiero1.name : "");
    const [financieroOneClave, setFinancieroOneClave] = useState((contrato.financiero1?.password) ? contrato.financiero1.password : "");
    const [financieroTwoCorreo, setFinancieroTwoCorreo] = useState((contrato.financiero2?.email) ? contrato.financiero2.email : "");
    const [financieroTwoNombre, setFinancieroTwoNombre] = useState((contrato.financiero2?.name) ? contrato.financiero2.name : "");
    const [financieroTwoClave, setFinancieroTwoClave] = useState((contrato.financiero2?.password) ? contrato.financiero2.password : "");
    const [clasificacionComercial, setClasificacionComercial] = useState((contrato.clasificacionComercial) ? contrato.clasificacionComercial.value : null);
    const [clasificacionSubComercial, setClasificacionSubComercial] = useState((contrato.clasificacionSubComercial) ? contrato.clasificacionSubComercial.value : null);
    const [categoria, setCategoria] = useState((contrato.categoria) ? contrato.categoria.value : null);

    useEffect(() => {
        setValue('clasificacionComercial', clasificacionComercial)
        setValue('clasificacionSubComercial', clasificacionSubComercial)
        setValue('categoria', categoria)
    })

    const handleUpdate = () => {
        // console.log('values', getValues())
        setUpdateLocatario(true)
    }

    const [updateLocatario, setUpdateLocatario] = useState(false);

    let { data: dataResponse, isLoading: isLoadingResponse } = useQuery([KeyNames.SessionRespuesta,
    {
        numContrato: contrato.numContrato,
        operador_correo: operadorCorreo,
        operador_nombre: operadorNombre,
        operador_contrasenia: operadorClave,
        administrador_correo: administradorCorreo,
        administrador_contrasenia: administradorClave,
        administrador_nombre: administradorNombre,
        financiero1_correo: financieroOneCorreo,
        financiero1_contrasenia: financieroOneClave,
        financiero1_nombre: financieroOneNombre,
        financiero2_correo: financieroTwoCorreo,
        financiero2_contrasenia: financieroTwoClave,
        financiero2_nombre: financieroTwoNombre,
        clasificacionComercialId: clasificacionComercial,
        clasificacionSubComercialId: clasificacionSubComercial,
        categoriaId: categoria,
        token: token
    }],
        async () => await Api.ActualizarLocatario(
            {
                numContrato: contrato.numContrato,
                operador_correo: operadorCorreo,
                operador_nombre: operadorNombre,
                operador_contrasenia: operadorClave,
                administrador_correo: administradorCorreo,
                administrador_contrasenia: administradorClave,
                administrador_nombre: administradorNombre,
                financiero1_correo: financieroOneCorreo,
                financiero1_contrasenia: financieroOneClave,
                financiero1_nombre: financieroOneNombre,
                financiero2_correo: financieroTwoCorreo,
                financiero2_contrasenia: financieroTwoClave,
                financiero2_nombre: financieroTwoNombre,
                clasificacionComercialId: clasificacionComercial,
                clasificacionSubComercialId: clasificacionSubComercial,
                categoriaId: categoria,
                token: token
            }
        ),
        {
            enabled: Boolean(updateLocatario)
        });

    useEffect(() => {
        if (dataResponse) {
            if (!dataResponse.success)
                setFeedbackContext({ ...feedbackContext, showError: true, idError: dataResponse.errorId });
            else {
                reset()
                setUpdateLocatario(false);
                setSmShow(true);
            }
        }
    }, [dataResponse]);

    const hideModal = () => {
        setSmShow(false)
    }

    const handleChangeEmailOperador = (e) => {
        setOperadorCorreo(e.target.value)
    }

    const handleChangeNameOperador = (e) => {
        setOperadorNombre(e.target.value)
    }

    const handleChangeClaveOperador = (e) => {
        setOperadorClave(e.target.value)
    }

    const handleChangeEmailAdmin = (e) => {
        setAdministradorCorreo(e.target.value)
    }

    const handleChangeNameAdmin = (e) => {
        setAdministradorNombre(e.target.value)
    }

    const handleChangeClaveAdmin = (e) => {
        setAdministradorClave(e.target.value)
    }

    const handleChangeEmailFinancieroOne = (e) => {
        setFinancieroOneCorreo(e.target.value)
    }

    const handleChangeNameFinancieroOne = (e) => {
        setFinancieroOneNombre(e.target.value)
    }

    const handleChangeClaveFinancieroOne = (e) => {
        setFinancieroOneClave(e.target.value)
    }

    const handleChangeEmailFinancieroTwo = (e) => {
        setFinancieroTwoCorreo(e.target.value)
    }

    const handleChangeNameFinancieroTwo = (e) => {
        setFinancieroTwoNombre(e.target.value)
    }

    const handleChangeClaveFinancieroTwo = (e) => {
        setFinancieroTwoClave(e.target.value)
    }

    const handleChangeComercial = (e) => {
        setValue('clasificacionComercial', e.target.value)
        setClasificacionComercial(e.target.value)
    }

    const handleChangeSubComercial = (e) => {
        setValue('clasificacionSubComercial', e.target.value)
        setClasificacionSubComercial(e.target.value)
    }

    const handleChangeCategoria = (e) => {
        setValue('categoria', e.target.value)
        setCategoria(e.target.value)
    }

    return (
        <>
            <Modal size="lg" show={true} onHide={hideModal}>
                <Modal.Header className='modal-header'>
                    <Modal.Title className='fw-bolder d-flex justify-content-end'>
                        <div className='p-2'>Gestionar: {<span> {contrato.nombre} ({contrato.numContrato})</span>}
                        </div>
                        {isLoadingResponse && <Loading />}
                    </Modal.Title>
                    <button type="button" onClick={hideModal} className="btn btn-icon btn-sm btn-active-icon-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black"></rect>
                            <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black"></rect>
                        </svg>
                    </button>
                </Modal.Header>
                <Modal.Body className='modal-body mx-5 mx-xl-10 my-7'>
                    <div className="mb-5">
                        <label className="text-gray-900 fs-2 fw-bolder me-1">Operador</label>

                    </div>

                    <div className="row mb-10">

                        <div className="col-md-4">
                            <label className=' fs-6 fw-bold form-label mb-2'>Correo</label>
                            <input {...register("emailOperador", { required: true })} placeholder="Correo electrónico" type="text" className='form-control form-control-solid mb-3 mb-lg-0' onChange={handleChangeEmailOperador} value={operadorCorreo} />
                            <>{errors.emailOperador && <span className="text-danger">El campo es obligatorio</span>}</>
                        </div>
                        <div className="col-md-4">
                            <label className=' fs-6 fw-bold form-label mb-2'>Nombre</label>
                            <input {...register("nameOperador", { required: true })} placeholder="Nombre" type="text" className='form-control form-control-solid mb-3 mb-lg-0' onChange={handleChangeNameOperador} value={operadorNombre} />
                            <>{errors.nameOperador && <span className="text-danger">El campo es obligatorio</span>}</>
                        </div>
                        <div className="col-md-4">
                            <label className=' fs-6 fw-bold form-label mb-2'> Clave</label>
                            <input {...register("passwordOperador", { required: true })} placeholder="Clave" type="text" className='form-control form-control-solid mb-3 mb-lg-0' onChange={handleChangeClaveOperador} value={operadorClave} />
                            <>{errors.passwordOperador && <span className="text-danger">El campo es obligatorio</span>}</>
                        </div>
                    </div>
                    <div className="mb-5">
                        <label className="text-gray-900 fs-2 fw-bolder me-1">Administrador</label>

                    </div>
                    <div className="row mb-10">
                        <div className="col-md-4">
                            <label className=' fs-6 fw-bold form-label mb-2'>Correo</label>
                            <input {...register("emailAdministrador", { required: true })} placeholder="Correo electrónico" type="text" className='form-control form-control-solid mb-3 mb-lg-0' onChange={handleChangeEmailAdmin} value={administradorCorreo} />
                            <>{errors.emailAdministrador && <span className="text-danger">El campo es obligatorio</span>}</>
                        </div>
                        <div className="col-md-4">
                            <label className=' fs-6 fw-bold form-label mb-2'>Nombre</label>
                            <input {...register("nameAdministrador", { required: true })} placeholder="Nombre" type="text" className='form-control form-control-solid mb-3 mb-lg-0' onChange={handleChangeNameAdmin} value={administradorNombre} />
                            <>{errors.nameAdministrador && <span className="text-danger">El campo es obligatorio</span>}</>
                        </div>
                        <div className="col-md-4">
                            <label className=' fs-6 fw-bold form-label mb-2'> Clave</label>
                            <input {...register("passwordAdministrador", { required: true })} placeholder="Clave" type="text" className='form-control form-control-solid mb-3 mb-lg-0' onChange={handleChangeClaveAdmin} value={administradorClave} />
                            <>{errors.passwordAdministrador && <span className="text-danger">El campo es obligatorio</span>}</>
                        </div>
                    </div>

                    <div className="mb-5">
                        <label className="text-gray-900 fs-2 fw-bolder me-1">Financiero 1</label>
                    </div>
                    <div className="row mb-10">
                        <div className="col-md-4">
                            <label className=' fs-6 fw-bold form-label mb-2'>Correo</label>
                            <input {...register("emailFinancieroOne")} placeholder="Correo electrónico" type="text" className='form-control form-control-solid mb-3 mb-lg-0' onChange={handleChangeEmailFinancieroOne} value={financieroOneCorreo} />
                        </div>
                        <div className="col-md-4">
                            <label className=' fs-6 fw-bold form-label mb-2'>Nombre</label>
                            <input {...register("nameFinancieroOne")} placeholder="Nombre" type="text" className='form-control form-control-solid mb-3 mb-lg-0' onChange={handleChangeNameFinancieroOne} value={financieroOneNombre} />
                        </div>
                        <div className="col-md-4">
                            <label className=' fs-6 fw-bold form-label mb-2'> Clave</label>
                            <input {...register("passwordFinancieroOne")} placeholder="Clave" type="text" className='form-control form-control-solid mb-3 mb-lg-0' onChange={handleChangeClaveFinancieroOne} value={financieroOneClave} />
                        </div>
                    </div>

                    <div className="mb-5">
                        <label className="text-gray-900 fs-2 fw-bolder me-1">Financiero 2</label>
                    </div>
                    <div className="row mb-10">
                        <div className="col-md-4">
                            <label className=' fs-6 fw-bold form-label mb-2'>Correo</label>
                            <input {...register("emailFinancieroTwo")} placeholder="Correo electrónico" type="text" className='form-control form-control-solid mb-3 mb-lg-0' onChange={handleChangeEmailFinancieroTwo} value={financieroTwoCorreo} />
                        </div>
                        <div className="col-md-4">
                            <label className=' fs-6 fw-bold form-label mb-2'>Nombre</label>
                            <input {...register("nameFinancieroTwo")} placeholder="Nombre" type="text" className='form-control form-control-solid mb-3 mb-lg-0' onChange={handleChangeNameFinancieroTwo} value={financieroTwoNombre} />
                        </div>
                        <div className="col-md-4">
                            <label className=' fs-6 fw-bold form-label mb-2'> Clave</label>
                            <input {...register("passwordFinancieroTwo")} placeholder="Clave" type="text" className='form-control form-control-solid mb-3 mb-lg-0' onChange={handleChangeClaveFinancieroTwo} value={financieroTwoClave} />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4">
                            <div className="p-2" style={{ minWidth: "200px" }}>
                                <label className=' fs-6 fw-bold form-label mb-2'>Clasificación  Comercial</label>
                                <select
                                    defaultValue={clasificacionComercial}
                                    {...register("clasificacionComercial", { required: true })}
                                    className="form-select form-select-solid filter"
                                    value={clasificacionComercial}
                                    onChange={handleChangeComercial}
                                >
                                    <option value="">Selecciona una opción</option>
                                    {listaClasificacionComercial.list.map((item, index) =>
                                        <option value={item.value} key={index}>{item.label}</option>
                                    )}
                                </select>
                                <>{errors.clasificacionComercial && <span className="text-danger">El campo es obligatorio</span>}</>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="p-2" style={{ minWidth: "200px" }}>
                                <label className="fs-6 fw-bold form-label mb-2">Clasificación  SubComercial:</label>
                                <select
                                    defaultValue={clasificacionSubComercial}
                                    {...register("clasificacionSubComercial", { required: true })}
                                    className="form-select form-select-solid filter"
                                    value={clasificacionSubComercial}
                                    onChange={handleChangeSubComercial}
                                >
                                    <option value="">Selecciona una opción</option>
                                    {listaClasificacionSubComercial.list.map((item, index) =>
                                        <option value={item.value} key={index}>{item.label}</option>
                                    )}
                                </select>

                                <>{errors.clasificacionSubComercial && <span className="text-danger">El campo es obligatorio</span>}</>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="p-2" style={{ minWidth: "200px" }}>
                                <label className="fs-6 fw-bold form-label mb-2">Categoria:</label>
                                <select
                                    defaultValue={categoria}
                                    {...register("categoria", { required: true })}
                                    className="form-select form-select-solid filter"
                                    value={categoria}
                                    onChange={handleChangeCategoria}
                                >
                                    <option value="">Selecciona una opción</option>
                                    {listaCategoria.list.map((item, index) =>
                                        <option value={item.value} key={index}>{item.label}</option>
                                    )}
                                </select>
                                <>{errors.categoria && <span className="text-danger">El campo es obligatorio</span>}</>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer className='text-center'>
                    <button className="btn btn-light me-3" onClick={hideModal}>
                        Cerrar
                    </button>
                    <button className="btn btn-primary" onClick={handleSubmit(handleUpdate)}>
                        Actualizar
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}